import {
    HomeOutlined,
  } from "@mui/icons-material";
import { Dashboard } from './pages/Dashboard';
import { SideBarItems } from './components/Sidebar';
import { Logger } from './utils/Logger';
// Import ModulesMenu specifically from 'modules/Settings'
import { ModulesMenu as SettingsModulesMenuArray } from './modules/Settings/Menu'; 
import { ModulesMenu as AdministrationModulesMenuArray } from './modules/Administration/Menu';
import { ModulesMenu as InstantUpdateModuleMenu } from './modules/InstantUpdate';
import { ModulesMenu as CampaignModuleMenu } from './modules/CampaignManagement';
import { ModulesMenu as AutomateTestModuleMenu } from './modules/AutomateTest';
import { ModulesMenu as AssetManagementModuleMenu } from './modules/AssetManagement';
import { ModulesMenu as InfralytiqsModuleMenu } from './modules/Infralytiqs';
import { ModulesMenu as ManagePlanModuleMenu } from './modules/ManagePlan';
import { ModulesMenu as SupportModuleMenu } from './modules/Support';
import { ModulesMenu as AnamnesisModuleMenu } from './modules/Anamnesis';
import { ModulesMenu as BeamOnScreenModuleMenu } from './modules/BeamOnScreen';
import { FALLBACK_MENU_KEY } from './constants/clientConfigFallback';
  
const DEFAULT_MENU_KEY = FALLBACK_MENU_KEY;

// Define all menu items with menuKey, then export filtered by brand
const ALL_SIDEBAR_MENU_ITEMS: SideBarItems[] = [
  {
    path:"/",
    urlKey: "dashboard",
    text: "Dashboard",
    icon: <HomeOutlined />,
    type: "menuItem",
    menuKey: "campaignKing",
    module: <Dashboard />,
    dictionaryKey: "sidebar-menu-dashboard",
  },
  {
    path:"/",
    urlKey: "dashboard",
    text: "Dashboard",
    icon: <HomeOutlined />,
    type: "menuItem",
    menuKey: "instantUpdate",
    module: <Dashboard />,
    dictionaryKey: "sidebar-menu-dashboard",
  },
  {
    path:"/",
    urlKey: "dashboard",
    text: "Dashboard",
    icon: <HomeOutlined />,
    type: "menuItem",
    menuKey: "anamnesis",
    module: <Dashboard />,
    dictionaryKey: "sidebar-menu-dashboard",
  },
  {
    path:"/",
    urlKey: "dashboard",
    text: "Dashboard",
    icon: <HomeOutlined />,
    type: "menuItem",
    menuKey: "infralytiqs",
    module: <Dashboard />,
    dictionaryKey: "sidebar-menu-dashboard",
  },

  // Spread module menus (their entries will include menuKey)
  ...SettingsModulesMenuArray,
  ...InstantUpdateModuleMenu,
  ...AdministrationModulesMenuArray,
  ...AutomateTestModuleMenu,
  ...AssetManagementModuleMenu,
  ...InfralytiqsModuleMenu,
  ...ManagePlanModuleMenu,
  ...SupportModuleMenu,
  ...AnamnesisModuleMenu,
  ...BeamOnScreenModuleMenu,
  // ...CampaignModuleMenu
];

const filterByMenuKey = (item: SideBarItems, activeMenuKey: string): SideBarItems | null => {
  if (item.items && item.items.length > 0) {
    const filteredChildren = item.items
      .map(child => filterByMenuKey(child, activeMenuKey))
      .filter((x): x is SideBarItems => x !== null);

    if ((item.menuKey === activeMenuKey) && filteredChildren.length > 0) {
      return { ...item, items: filteredChildren };
    }
    return null;
  }

  return item.menuKey === activeMenuKey ? item : null;
};

/**
 * Returns sidebar menu items filtered by the active menu key.
 * The menuKey is supplied by the server via /system/client/config and stored
 * in the Redux `clientConfig` slice.  Callers (e.g. App.tsx) pass it in.
 */
export const getSideBarMenuItems = (menuKey?: string): SideBarItems[] => {
  const activeMenuKey = menuKey || DEFAULT_MENU_KEY;
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const filtered = ALL_SIDEBAR_MENU_ITEMS
    .map(item => filterByMenuKey(item, activeMenuKey))
    .filter((x): x is SideBarItems => x !== null);
  try {
    Logger.debug('st-ck-client/src/SiteMenu.tsx', { hostname, activeMenuKey, total: ALL_SIDEBAR_MENU_ITEMS.length, filtered: filtered.length });
  } catch {}
  return filtered;
};
